import styled from 'styled-components'

const Frame = styled.div`
  height: 360px;
  width: 270px;
  background-color: ${p => p.theme.color.backgroundRush};
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 15px;
  box-shadow: ${p => p.theme.shadow.m};
  color: ${p => p.color};
  transition: all 0.35s ease;
  :not(:last-child) {
    margin-right: 40px;
  }
  a { 
    color: inherit; 
    text-decoration: none;
    height: ${props => props.withVideo ? '270px' : '100%'};
    width: 100%;
    margin-bottom: ${props => props.withVideo ? 35 : 0}px;
    cursor: pointer;
  }
  &, * {
    box-sizing: border-box;
  }
`

const LogoWithName = styled.div`
  height: 265px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.35s ease;
  padding-top: 85px;
  svg {
    fill: ${p => p.color};
  }
  p {
    font-family: Medium;
  }
  svg {
    height: 50px;
    width: 50px;
  }
`

const Border = styled.div`
  height: 5px;
  width: 180px;
  background-color: ${p => p.theme.color.background};
  border-radius: 5px;
  transition: all 0.35s ease;
`

const ProductInfo = styled.div`
  height: ${props => props.withVideo ? '270px' : '100%'};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  &:hover {
    ${Frame}{
      box-shadow: ${p => p.theme.shadow.xl};
    }
    ${LogoWithName}{
      padding-top: 65px; 
    }
    ${Border}{
      background-color: ${p => p.color};
    }
  }
`

const ProductName = styled.p`
  height: 20px;
  font-size: 18px;
  margin-top: 40px;
`


const AdditionalInfo = styled.p`
  height: 14px;
  font-size: 12px;
  margin-top: 20px;
`


export const Styled = {
  Frame,
  ProductInfo,
  LogoWithName,
  ProductName,
  Border,
  AdditionalInfo
}
